/**
 * FeedbackButton — floating action button in bottom-left corner.
 * Opens the feedback modal when clicked.
 */

import { MessageSquarePlus } from 'lucide-react';
import { cn } from '@/lib/utils';

interface FeedbackButtonProps {
  onClick: () => void;
  className?: string;
}

export function FeedbackButton({ onClick, className }: FeedbackButtonProps) {
  return (
    <button
      onClick={onClick}
      className={cn(
        'bg-primary text-primary-foreground fixed bottom-4 left-4 z-40',
        'flex h-10 w-10 items-center justify-center rounded-full shadow-lg',
        'transition-transform hover:scale-110 active:scale-95',
        className
      )}
      title="Send feedback"
    >
      <MessageSquarePlus className="h-5 w-5" />
    </button>
  );
}
